import { compose, lifecycle, withHandlers, withStateHandlers, mapProps } from 'recompose'


export default compose(
  withStateHandlers(
    () => ({
      orderBy: null,
      orderAsc: false
    }),
    {
      setActiveColumn: () => (orderBy, orderAsc) => ({
        orderBy,
        orderAsc
      })
    }
  ),
  // Handlers
  withHandlers({
    onSortClick: ({
      onSortClick, setActiveColumn, orderAsc, orderBy 
    }) => (column) => {
      const order = orderBy === column.field && !orderAsc

      setActiveColumn(column.field, order)
      onSortClick({ key: column.orderField || column.field, value: order ? 'ASC' : 'DESC' })
    }
  }),
  lifecycle({
  }),
  mapProps((props) => {
    return props
  })
)



// WEBPACK FOOTER //
// ./src/components/organisms/DataTable/DataTable.enhancer.js